import Observable from '../helpers/observerable'
import { Decoder, Encoder, tools, Reader } from 'ts-ebml'
import debounce from 'lodash/debounce'
import { WebCodecRecorder, MixEncodedChunk } from './wbcRecorder'
// import MUXERModule from './libmp4muxer'

export class EventRecordManager {
    instance = null
    constructor(props) {
        if (this.instance === null) {
            this.instance = new CycleByfferEventRecordManagerImplement(props)
        }
        return this.instance
    }
}

// 因為 MediaRecorder 只有在 start 與 pause 後 start 的第一包資料有 webm file header
// 所以 prebuffer 不能直接 cache chunk 直接合併，而是要用2個 media recorder 去交互
// const audioCtx = new (window.AudioContext || window.webkitAudioContext)()
const FPS = 15
const PREBUFFER_TIME = 2000
const MIN_MEDIA_TIME = 5000 // 5 sec

let MAX_MEDIA_TIME = 30000 // 30 sec
const MEDIA_SLICE_SIZE = 200

const DETECT_FAIL_THRESHOLD = 15

function get_now() {
    return new Date().getTime()
}
class BufferPlant {
    /* 
                    {t2h_buffer_zone} [2~5]
    frames | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 |10 |
                 ^ cursor [1]        ^ read head/tail [6]
    
                 >>> frames will update in this direction >>>
    */
    constructor(frame_width, frame_height, buffer_frame, fps) {
        this.fps = fps
        this.tail2head_buffer_zone = 5
        this.buffer_frame = buffer_frame
        this.size = buffer_frame + this.tail2head_buffer_zone
        this.width = frame_width
        this.height = frame_height
        this.canvas = []
        this.ctx_list = []
        this.ctx_read_state = []
        this.ctx_last_read = null
        for (let i = 0; i < this.size; i++) {
            this.canvas.push(new OffscreenCanvas(this.width, this.height))
            this.ctx_list.push(this.canvas[i].getContext('2d'))
            this.ctx_read_state.push(false)
        }
        // this.canvas = document.getElementById('buffer')
        // this.canvas.height = this.height * this.size
        // this.canvas.width = this.width

        this.cursor = 0

        this.debug = window.alfredTest2wsxsw2
        this.frame_cnt = 0
    }

    flush() {
        this.frame_cnt = 0
        this.cursor = 0
        for (const ctx of this.ctx_list) {
            ctx.clearRect(0, 0, this.width, this.height)
        }
    }

    filled() {
        return this.frame_cnt >= this.canvas.length
    }

    buffer_frames() {
        return Math.min(this.frame_cnt, this.buffer_frame)
    }

    append(img_src) {
        const src_h =
            img_src instanceof HTMLVideoElement
                ? img_src.videoHeight
                : img_src.height
        const src_w =
            img_src instanceof HTMLVideoElement
                ? img_src.videoWidth
                : img_src.width
        // const offset_y = this.height * this.cursor
        const ctx = this.ctx_list[this.cursor]
        ctx.clearRect(0, 0, this.width, this.height)
        ctx.drawImage(
            img_src,
            0,
            0,
            src_w,
            src_h,
            0,
            0,
            this.width,
            this.height
        )

        if (this.debug) {
            const now = new Date()
            const timestamp = `R ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getUTCMilliseconds()}`

            ctx.fillStyle = '#333333'
            ctx.fillRect(35, 8, 120, 35)

            ctx.fillStyle = '#fcc35d'
            ctx.font = '14px Arial'
            ctx.fillText(`${this.frame_cnt} ${timestamp}`, 40, 20)

            let missing_read = 0
            for (let i = 0; i < this.tail2head_buffer_zone; i++)
                missing_read += !this.ctx_read_state[
                    (this.cursor + i) % this.size
                ]
            ctx.fillText(
                `${missing_read} / ${this.tail2head_buffer_zone}`,
                40,
                40
            )
        }

        this.ctx_read_state[this.cursor] = false
        this.cursor = (this.cursor + 1) % this.size
        this.frame_cnt++
    }

    read_head_to_ctx(ctx, h, w, video_track = null) {
        const offset = (this.cursor + this.tail2head_buffer_zone) % this.size
        this.ctx_read_state[offset] = true
        const miss_draw = Math.round(
            Math.max(get_now() - this.ctx_last_read - 1000 / this.fps, 0) /
                (1000 / this.fps)
        )
        let draw_times = this.ctx_last_read == null ? 1 : miss_draw + 1
        this.ctx_last_read = get_now()

        ctx.drawImage(
            this.canvas[offset],
            0,
            0,
            this.width,
            this.height,
            0,
            0,
            w,
            h
        )

        if (this.debug) {
            const now = new Date()
            const timestamp = `W ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getUTCMilliseconds()}`

            ctx.fillStyle = '#111111'
            ctx.fillRect(35, 8 + 38, 120, 18)
            ctx.fillStyle = '#fcc35d'
            ctx.font = '14px Arial'
            ctx.fillText(`${this.frame_cnt} ${timestamp}`, 40, 60)
        }
    }
}

class BufferPlantRecorder {
    constructor(src_canvas, sourceStream, buf, w, h, fps = 15) {
        this.fps = fps
        this.buf = buf
        // this.src_canvas = new OffscreenCanvas(w, h)
        // this.src_canvas = document.getElementById('record')
        this.src_canvas = src_canvas // NOTE: must be DOM canvas, offscreen canvas don't support capture stream method
        this.src_canvas.height = h
        this.src_canvas.width = w
        this.src_ctx = this.src_canvas.getContext('2d')
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)()

        let stream = [
            this.src_canvas.captureStream(this.fps).getVideoTracks()[0],
        ]
        if (sourceStream) {
            if (sourceStream.getAudioTracks()[0]) {
                const delay_media_stream = this.delay_audio_stream(sourceStream)
                stream.push(delay_media_stream.getAudioTracks()[0])
            }
        }
        this.vid_aud_track = stream
        this.canvas_stream = new MediaStream(stream)
        window.logManager.log('canvas_stream: ', this.canvas_stream)
        // TODO: switch recorder base on chrome version
        if (window.VideoEncoder !== undefined) {
            this.mediaRecorder = new WebCodecRecorder(this.canvas_stream)
            this.videoType = 'mp4'
        } else {
            this.mediaRecorder = new MediaRecorder(this.canvas_stream, {
                mimeType: 'video/webm;codecs=vp8',
            })
            this.videoType = 'vp8'
        }
        this.mediaRecorder.ondataavailable = (blobEvent) => {
            // console.log('hiiiiiii homiet6')
            this.handle_chunk.call(this, blobEvent)
        }
        this.record_chunks = []

        this.pullInterval = null
        this.handleDataAvailable = null
    }

    delay_audio_stream(sourceStream) {
        let streamNode = this.audioCtx.createMediaStreamSource(sourceStream)
        let delayNode = this.audioCtx.createDelay(PREBUFFER_TIME / 1000 + 1)
        let masterNode = this.audioCtx.createGain()

        //controls
        delayNode.delayTime.value = PREBUFFER_TIME / 1000

        //wire up nodes
        streamNode.connect(delayNode)
        delayNode.connect(masterNode)

        let dist = this.audioCtx.createMediaStreamDestination()
        masterNode.connect(dist)
        return dist.stream
    }

    handle_chunk(event) {
        if (event instanceof MixEncodedChunk) {
            this.record_chunks.push(event)
        } else {
            this.record_chunks.push(event.data)
        }

        window.logManager.log(
            'recorder data: ',
            event,
            this.record_chunks.length
        )
        if (this.handleDataAvailable) {
            this.handleDataAvailable(event)
        }
    }

    start_record() {
        if (this.pullInterval !== null)
            throw Error('Record is already started!')

        this.buf.read_head_to_ctx(
            this.src_ctx,
            this.src_canvas.height,
            this.src_canvas.width
        )

        this.record_chunks = []
        this.pullInterval = setInterval(() => {
            this.buf.read_head_to_ctx(
                this.src_ctx,
                this.src_canvas.height,
                this.src_canvas.width,
                this.vid_aud_track[0]
            )
            // this.src_ctx.fillRect(0, 0, 10 + this.buf.frame_cnt, 20)
        }, 1000 / this.fps)

        this.mediaRecorder.start(MEDIA_SLICE_SIZE)
        window.logManager.log('start record: ', this.buf.frame_cnt)
    }

    end() {
        const delay_end = (resolve, reject) => {
            const buf_time = (1000 / this.fps) * this.buf.buffer_frame
            setTimeout(() => {
                this.mediaRecorder.onstop = () => {
                    clearInterval(this.pullInterval)
                    this.pullInterval = null
                    // _downloadBlob({
                    //     blob: new Blob(this.record_chunks),
                    //     name: 'bufferplant.webm'
                    // })
                    resolve()
                }
                if (this.mediaRecorder.state === 'recording') {
                    this.mediaRecorder.stop()
                }
            }, buf_time)
        }
        return new Promise(delay_end)
    }

    graceful_end() {
        // NOTE: graceful end should alway followed by a buffer flush
        const delay_end = (resolve, reject) => {
            const buf_time = (1000 / this.fps) * this.buf.buffer_frame
            const fill_blank = setInterval(() => {
                // update buffer cursor by append fake/old frames
                this.buf.append(this.src_canvas)
            }, 1000 / this.fps)

            setTimeout(() => {
                this.mediaRecorder.onstop = () => {
                    clearInterval(this.pullInterval)
                    clearInterval(fill_blank)
                    this.pullInterval = null
                    resolve()
                }
                if (this.mediaRecorder.state === 'recording') {
                    this.mediaRecorder.stop()
                }
            }, buf_time)
        }
        return new Promise(delay_end)
    }

    flush() {
        this.buf.flush()
    }

    dump_chunks() {
        if (this.mediaRecorder.state == 'inactive') {
            let tmp = [...this.record_chunks]
            this.record_chunks = []
            return tmp
        } else {
            throw Error(
                "Can't dump recording chunks when recorder is still running"
            )
        }
    }
}

class CycleByfferEventRecordManagerImplement {
    constructor({
        record_canvas,
        frame_height,
        frame_width,
        isFree,
        sourceStream,
    }) {
        if (!isFree) {
            MAX_MEDIA_TIME = 120000
        } else {
            MAX_MEDIA_TIME = 30000
        }

        this.isStart = false
        this.isStop = false
        this.stopTime = get_now()
        // this.codec = 'video/webm;codecs=vp8'
        this.observable = new Observable()
        this.eventTimestamp = null
        this.startRecordingTimestamp = null

        // NOTE: you should update buffer_holder.canvas from graphic pipeline's output callback
        this.buffer_holder = new BufferPlant(
            frame_width,
            frame_height,
            FPS * (PREBUFFER_TIME / 1000),
            FPS
        )
        this.recorder = new BufferPlantRecorder(
            record_canvas,
            sourceStream,
            this.buffer_holder,
            frame_width,
            frame_height,
            FPS
        )
        this.recorder.handleDataAvailable = this.handleDataAvailable.bind(this)
    }

    async notifyVideoFile(data_chunks, duration) {
        // drop video if record time is shorter than 5 sec
        if (duration < MIN_MEDIA_TIME / 1000) return

        const eventTimestamp = this.eventTimestamp

        if (this.recorder.mediaRecorder instanceof MediaRecorder) {
            // post processing webm blob from MediaRecorder
            const videoData = new Blob(data_chunks, {
                type: data_chunks[0].type,
            })
            let raw_data = await videoData.arrayBuffer()
            let array = new Uint8Array(raw_data)
            let id = array.findIndex((e, i, a) => {
                return (
                    e == 26 &&
                    a[i + 1] == 69 &&
                    a[i + 2] == 223 &&
                    a[i + 3] == 163 &&
                    a[i + 4] == 159
                )
            })
            if (id < 0)
                throw Error(`Can't find WebM header address in Blob: ${id}`)
            let align_buffer = raw_data.slice(id)
            let alignVideoData = new Blob([align_buffer], {
                type: videoData.type,
            })
            alignVideoData = await injectMetadata(alignVideoData)
            this.observable.notify({
                type: 'video',
                data: {
                    videoData: alignVideoData,
                    eventTimestamp,
                    duration: Math.floor(duration),
                    vsize: alignVideoData.size,
                    eventType: this.eventType,
                },
            })
        } else {
            const mp4_buf = await this.recorder.mediaRecorder.mux(data_chunks)
            const mp4_blob = new Blob([mp4_buf], { type: 'video/mp4' })
            if (mp4_blob.size == 0) debugger

            this.observable.notify({
                type: 'video',
                data: {
                    videoData: mp4_blob,
                    eventTimestamp,
                    duration: Math.floor(duration),
                    vsize: mp4_blob.size,
                    eventType: this.eventType,
                },
            })
            // _downloadBlob({
            //     blob: mp4_blob,
            //     name: 'webcam.mp4',
            // })
        }

        this.chunks = []
        this.recorder_mode = 'idle'
        window.logManager.log('[EventRecorder] notifyVideoFile')
    }

    handleDataAvailable(event) {
        const now = new Date().getTime()
        const duration = (now - this.startRecordingTimestamp) / 1000
        window.logManager.log('[EventRecorder] handleDataAvailable ', duration)
        const buffer_time = (this.buffer_holder.buffer_frames() / FPS) * 1000
        if (duration > (MAX_MEDIA_TIME - buffer_time) / 1000 && !this.isStop) {
            this.stopRecording()
        }
    }

    startRecording(eventStartTime, eventType) {
        if (
            this.isStart === false &&
            this.buffer_holder.filled() &&
            !this.isStop
        ) {
            this.isStart = true
            this.startRecordingTimestamp = get_now()
            this.eventTimestamp = eventStartTime
            this.eventType = eventType
            this.recorder.start_record()
            window.logManager.log(
                '[EventRecorder] startRecording',
                this.recorder
            )
            return true
        }
        // console.log('[EventRecorder] startRecording', this.recorder, false)
        return false
    }

    stopRecording() {
        // stop recording but still not fill enough time
        if (this.isStart === true && !this.isStop) {
            window.logManager.log('[EventRecorder] stopRecording')
            this.isStop = true
            this.recorder.end().then(() => {
                this.isStart = false
                const now = get_now()
                const duration = (now - this.startRecordingTimestamp) / 1000
                this.stopTime = get_now()
                let data_chunks = this.recorder.dump_chunks()
                this.notifyVideoFile(data_chunks, duration)
                this.isStop = false
            })
            return true
        }
        return false
    }

    flushRecorder() {
        // stop recording but still not fill enough time
        if (this.isStart === true && !this.isStop) {
            window.logManager.log('[EventRecorder] flushRecorder')
            this.isStop = true
            this.recorder.graceful_end().then(() => {
                this.isStart = false
                const now = get_now()
                const duration = (now - this.startRecordingTimestamp) / 1000
                this.stopTime = get_now()
                let data_chunks = this.recorder.dump_chunks()
                this.notifyVideoFile(data_chunks, duration).then(() =>
                    window.logManager.log('[EventRecorder] video uploaded!')
                )
                this.buffer_holder.flush()
                this.isStop = false
            })
            return true
        }
        return false
    }
}

export class EventStateHandler {
    constructor(
        record_manager,
        createEventWithSnapshot,
        onCreateEventSuccess,
        onMotionDetected,
        attachVideoToEvent,
        generateSnapshotForEvent,
        setReactState
    ) {
        this._record_manager = record_manager
        record_manager.observable.subscribe(
            this.handle_event_callback.bind(this)
        )
        this.videoType = record_manager.recorder.videoType

        this.record_state = {
            is_recording: 0,
            satatic_frame: 0,
            motion_frame: 0,
            eventStartTime: null,
        }

        this.external = {
            attachVideoToEvent,
            generateSnapshotForEvent, // already bind with video
            setReactState, // bind to camera stream compoent
            createEventWithSnapshot,
            onCreateEventSuccess,
            onMotionDetected,
        }
        this.eventTimeDataList = {}
    }

    async uploadVideo({ eventId, videoData, eventTimestamp, type }) {
        const videoName =
            this.videoType == 'webm'
                ? `${eventTimestamp}.webm`
                : `${eventTimestamp}.mp4`
        await this.external.attachVideoToEvent({
            eventId,
            type,
            videoName,
            vidType: this.videoType,
            ...videoData,
        })
        await this.external.onCreateEventSuccess(eventId, type, eventTimestamp)
        delete this.eventTimeDataList[eventTimestamp]
        // debugger
    }

    async create_event(eventStartTime, type, data) {
        if (this.record_state.is_recording > 0) {
            this.record_state.eventStartTime = eventStartTime
            // this.record_state.eventStartTime = new Date().getTime();
            const snapshotName = `${this.record_state.eventStartTime}.jpg`
            const snapshotData = await this.external.generateSnapshotForEvent()

            window.logManager.log(
                `[EventRecording] Snapshot generated ${eventStartTime}`
            )
            // debugger
            // don't block the loop
            this.external
                .createEventWithSnapshot({
                    snapshotData,
                    snapshotName,
                    type,
                    vidType: this.videoType,
                })
                .then(async (eventId) => {
                    const eventData = this.eventTimeDataList[eventStartTime]
                    if (!eventData || !eventData.videoData) {
                        this.eventTimeDataList[eventStartTime] = {
                            eventId,
                        }
                    } else {
                        await this.uploadVideo({
                            type,
                            eventId,
                            videoData: eventData.videoData,
                            eventTimestamp: eventStartTime,
                        })
                    }
                })
        }
    }

    tick(type, data) {
        switch (type) {
            case 'person':
            case 'motion':
                this.record_state.motion_frame++
                if (this.record_state.motion_frame >= 3) {
                    const eventStartTime = new Date().getTime()
                    const started_success = this._record_manager.startRecording(
                        eventStartTime,
                        type
                    )
                    window.logManager.log(
                        `%c [EventRecording] tick - ${type}: ${this.record_state.satatic_frame}`,
                        'color: rgb(0, 200, 200);'
                    )

                    if (started_success) {
                        window.logManager.log(
                            `%c [EventRecording] Detection Record start! ${this.record_state.is_recording}`,
                            'color: rgb(0, 200, 0);'
                        )
                        this.record_state.is_recording++
                        this.external.setReactState({
                            isRecording: this.record_state.is_recording > 0,
                        })
                        // HACK: unhandle promise
                        this.create_event(eventStartTime, type)
                    }
                    this.record_state.satatic_frame = 0
                    this.external.onMotionDetected()
                }
                break
            case 'nothing':
                if (this.record_state.is_recording > 0) {
                    this.record_state.satatic_frame++
                    window.logManager.log(
                        `%c [EventRecording] tick - nothing: ${this.record_state.satatic_frame}`,
                        'color: rgb(200, 20, 0);'
                    )
                    if (
                        this.record_state.satatic_frame > DETECT_FAIL_THRESHOLD
                    ) {
                        this._record_manager.stopRecording(
                            this.record_state.eventStartTime
                        )
                        this.reset_record_state()
                    }
                }
                break
            case 'interrupte':
                if (this.record_state.is_recording > 0) {
                    window.logManager.log(
                        `%c [EventRecording] tick - interrupte: ${this.record_state.satatic_frame}`,
                        'color: rgb(200, 20, 0);'
                    )
                    this._record_manager.flushRecorder(
                        this.record_state.eventStartTime
                    )
                    this.reset_record_state()
                }
                break
            default:
                throw Error(`Unknown event type: ${type}`)
        }
    }

    reset_record_state() {
        this.record_state.satatic_frame = 0
        this.record_state.motion_frame = 0
        this.record_state.is_recording = 0
        this.external.setReactState({
            isRecording: false,
        })
        window.logManager.log(
            '[EventRecording] Record end!',
            this.record_state.is_recording
        )
    }

    async handle_event_callback(msg) {
        // this method should subscribe to record manager
        switch (msg.type) {
            case 'video':
                const eventTimestamp = msg.data.eventTimestamp
                const eventData = this.eventTimeDataList[eventTimestamp]
                const videoData = {
                    ...msg.data,
                }

                if (eventData && eventData.eventId) {
                    await this.uploadVideo({
                        eventId: eventData.eventId,
                        videoData,
                        eventTimestamp,
                        type: msg.data.eventType,
                    })
                } else {
                    this.eventTimeDataList[eventTimestamp] = {
                        videoData,
                    }
                }
                break
            case 'record_time':
                this.external.setReactState({ recordTime: msg.data })
                break
            default:
                break
        }
    }
}

let _runed = false
async function _downloadBlob({ blob, name }) {
    // let data = await blob.arrayBuffer()
    // console.dir(data)
    // let array = new Uint8Array(data)
    // let id = array.findIndex((e, i, a) => {
    //     return e == 26 && a[i + 1] == 69 && a[i + 2] == 223
    // })
    // let align_array = data.slice(id)
    // // debugger
    // blob = new Blob([align_array], {type: data.type})
    // debugger
    // if (_runed)
    //     return
    // debugger
    const uri = URL.createObjectURL(blob)
    var link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    _runed = true
}

function _downloadSplitBlob({ blobs, name }) {
    // debugger
    const n = blobs.length
    if (_runed) return

    let key_frame = []
    for (let i = 0; i < blobs.length; i++) {
        if (blobs[i].size == 1) {
            key_frame.push(i)
        }
    }

    for (let i = 0; i < key_frame.length; i++) {
        const end = i == key_frame.length - 1 ? blobs.length : key_frame[i + 1]
        const slice_blob = blobs.slice(key_frame[i], end)

        let vid_slcie = new Blob(slice_blob, { type: blobs[0].type })
        _downloadBlob({ blob: vid_slcie, name })
    }

    let vid_slcie = new Blob(blobs, {
        type: blobs[0].type,
    })
    _downloadBlob({
        blob: vid_slcie,
        name: 'full.webm',
    })
    // for (let i = 0; i < blobs.length; i+=20) {
    //     let sblobs = blobs.slice(i, i + 5).concat(blobs.slice(i, i + 5))

    //     console.log(sblobs)
    //     let vid_slcie = new Blob(sblobs, {type: blobs[0].type})
    //     downloadBlob({blob: vid_slcie, name})
    // }
    _runed = true
}

const readAsArrayBuffer = function (blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsArrayBuffer(blob)
        reader.onloadend = () => {
            resolve(reader.result)
        }
        reader.onerror = (ev) => {
            reject(ev.error)
        }
    })
}

async function injectMetadata(blob) {
    const decoder = new Decoder()
    const reader = new Reader()
    reader.logging = false
    reader.drop_default_duration = false

    let buffer = await readAsArrayBuffer(blob)
    const elms = decoder.decode(buffer)
    elms.forEach((elm) => {
        // if (elm.type === "b" && elm.name === "SimpleBlock")
        // if (elm.name == "Block") {
        //     console.log("BLOCK: ", elm)
        // }
        reader.read(elm)
    })
    reader.stop()
    window.logManager.log(`[EMBL] duration: ${reader.duration}`)
    var refinedMetadataBuf = tools.makeMetadataSeekable(
        reader.metadatas,
        reader.duration,
        reader.cues
    )
    var body = buffer.slice(reader.metadataSize)

    const result = new Blob([refinedMetadataBuf, body], {
        type: blob.type,
    })

    return result
}
